module.exports = __webpack_public_path__ + "static/img/hero-snake-logo.9335a951.png";